/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { APIMeta } from './APIMeta';
import {
    APIMetaFromJSON,
    APIMetaFromJSONTyped,
    APIMetaToJSON,
} from './APIMeta';
import type { APIResponseError } from './APIResponseError';
import {
    APIResponseErrorFromJSON,
    APIResponseErrorFromJSONTyped,
    APIResponseErrorToJSON,
} from './APIResponseError';
import type { PersonRet } from './PersonRet';
import {
    PersonRetFromJSON,
    PersonRetFromJSONTyped,
    PersonRetToJSON,
} from './PersonRet';

/**
 * 
 * @export
 * @interface GetOrganizationsTeam200Response
 */
export interface GetOrganizationsTeam200Response {
    /**
     * 
     * @type {APIMeta}
     * @memberof GetOrganizationsTeam200Response
     */
    meta?: APIMeta;
    /**
     * 
     * @type {Array<APIResponseError>}
     * @memberof GetOrganizationsTeam200Response
     */
    errors?: Array<APIResponseError>;
    /**
     * 
     * @type {Array<PersonRet>}
     * @memberof GetOrganizationsTeam200Response
     */
    result: Array<PersonRet>;
}

/**
 * Check if a given object implements the GetOrganizationsTeam200Response interface.
 */
export function instanceOfGetOrganizationsTeam200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "result" in value;

    return isInstance;
}

export function GetOrganizationsTeam200ResponseFromJSON(json: any): GetOrganizationsTeam200Response {
    return GetOrganizationsTeam200ResponseFromJSONTyped(json, false);
}

export function GetOrganizationsTeam200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetOrganizationsTeam200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'meta': !exists(json, 'meta') ? undefined : APIMetaFromJSON(json['meta']),
        'errors': !exists(json, 'errors') ? undefined : ((json['errors'] as Array<any>).map(APIResponseErrorFromJSON)),
        'result': ((json['result'] as Array<any>).map(PersonRetFromJSON)),
    };
}

export function GetOrganizationsTeam200ResponseToJSON(value?: GetOrganizationsTeam200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'meta': APIMetaToJSON(value.meta),
        'errors': value.errors === undefined ? undefined : ((value.errors as Array<any>).map(APIResponseErrorToJSON)),
        'result': ((value.result as Array<any>).map(PersonRetToJSON)),
    };
}

